import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/AuthShell";
import { Field } from "@/components/kit";
import { api, errMsg } from "@/lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    await api.post("/auth/forgot-password", { email }).catch(() => {});
    setSent(true);
  };
  return (
    <AuthShell title="Reset password" subtitle="We'll email you a link to choose a new password." footer={<Link to="/login" className="text-[#CCFF00]">Back to log in</Link>}>
      {sent ? (
        <p className="text-slate-300" data-testid="forgot-sent-msg">If that email has an account, a reset link is on its way.</p>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <Field label="Email"><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></Field>
          <Button type="submit" className="h-11 w-full rounded-full font-bold uppercase" data-testid="forgot-submit-btn">Send reset link</Button>
        </form>
      )}
    </AuthShell>
  );
}

export function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please log in");
      nav("/login");
    } catch (err) {
      setError(errMsg(err));
    }
  };
  return (
    <AuthShell title="New password">
      <form onSubmit={submit} className="space-y-5">
        <Field label="New password" hint="At least 8 characters"><Input type="password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" /></Field>
        {error && <p className="text-sm text-rose-400" data-testid="reset-error">{error}</p>}
        <Button type="submit" className="h-11 w-full rounded-full font-bold uppercase" data-testid="reset-submit-btn">Update password</Button>
      </form>
    </AuthShell>
  );
}
